// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"cfd6a1de","102":"a47183d6","232":"cfd6a1de","481":"9fd304c0","565":"9036f8f6","572":"131c4c47","715":"a9b3f866"}[chunkId] + ".chunk.css";
};